import alert from '@jetbrains/ring-ui/components/alert-service/alert-service'
import Button from '@jetbrains/ring-ui/components/button/button'
import Confirm from '@jetbrains/ring-ui/components/confirm/confirm'
import * as React from 'react'
import {useMutation} from 'react-relay'

import type {AgentPoolPageRemoveAgentPoolMutation} from '../../../AgentPoolPage/__generated__/AgentPoolPageRemoveAgentPoolMutation.graphql'
import {removeAgentPool} from '../../../AgentPoolPage/AgentPoolPage.queries'

import styles from './DeleteAgentPoolButton.css'

type Props = {
  agentPoolRawId: string
  onRemove?: () => void
}

function DeleteAgentPoolButton({agentPoolRawId, onRemove}: Props): React.ReactElement {
  const [showDeleteConfirm, setShowDeleteConfirm] = React.useState(false)
  const handleDeleteClick = React.useCallback(
    () => setShowDeleteConfirm(true),
    [setShowDeleteConfirm],
  )
  const [commitRemove, isRemoving] =
    useMutation<AgentPoolPageRemoveAgentPoolMutation>(removeAgentPool)
  const onConfirmDelete = React.useCallback(() => {
    commitRemove({
      variables: {agentPoolRawId},
      onCompleted: (response, errors) => {
        if (errors == null) {
          if (onRemove != null) {
            onRemove()
          }
        } else {
          errors.forEach(error => alert.error(error.message))
        }
      },
      onError: error => {
        alert.error(error.message)
      },
    })
  }, [commitRemove, agentPoolRawId, onRemove])
  const onRejectDelete = React.useCallback(() => {
    setShowDeleteConfirm(false)
  }, [])
  return (
    <>
      <Button onClick={handleDeleteClick} className={styles.botton} loader={isRemoving}>
        {'Delete'}
      </Button>
      <Confirm
        className={styles.confirm}
        text="Delete this agent pool?"
        confirmLabel="Yes"
        rejectLabel="Cancel"
        show={showDeleteConfirm}
        onConfirm={onConfirmDelete}
        onReject={onRejectDelete}
      />
    </>
  )
}

export default DeleteAgentPoolButton
